module.exports = __webpack_public_path__ + "static/pakmaya-my-web-fb340a88b565a5c7f4edb186d1b85a9a.jpg";